module.exports = __webpack_public_path__ + "static/media/logo_windowsimulator@2x.6feca17a.png";